<template>
  <div>
    <a-menu
      theme="light"
      mode="inline"
      @click="selectMenu"
      :defaultOpenKeys="selectedOpenKeys"
      v-model="selectedKeys"
      :openKeys.sync="openKeys"
    >
      <template v-for="item in menuList">
        <a-sub-menu :key="item.id" v-if="getIsMenuList(item.children)">
          <span slot="title">
            <a-icon :type="item.icon" />
            <span>{{ item.label }}</span>
          </span>
          <template v-if="getIsMenuList(item.children)">
            <template v-for="childItem in item.children">
              <a-menu-item :key="childItem.id" v-if="!childItem.hidden">
                <router-link :to="childItem.path" tag="div">
                  {{ childItem.label }}
                </router-link>
              </a-menu-item>
            </template>
          </template>
        </a-sub-menu>
      </template>
    </a-menu>
  </div>
</template>
<script>
const menuData = require('./menu copy.js')
export default {
  data() {
    return {
      selectedOpenKeys: [1], //初始展开的 SubMenu 菜单项 key 数组
      selectedKeys: [2], // 当前选中的key
      menuList: [],
      openKeys: [1] //当前展开key
    }
  },
  created() {
    this.menuList = this.$store.state.app.queryUserMenuList
    this.getKeys()
  },
  mounted() {},
  watch: {
    $route() {
      // this.selectedKeys = [31]
      this.getKeys()
    }
  },
  methods: {
    //判断当前菜单是否有子集显示
    getIsMenuList(list) {
      let isMenuList = list.some((item) => {
        return item.hidden == false
      })
      return isMenuList
    },
    //获取当前所在页面左侧菜单的key
    getKeys() {
      this.menuList.forEach((item, index) => {
        if (item.children && item.children.length > 0) {
          //有子集
          item.children.forEach((value, index2) => {
            if (this.$route.path == value.path) {
              // console.log(value, item)
              this.selectedKeys = [value.id]
              this.openKeys = [item.id]
            }
          })
        }
      })
    },
    selectMenu({ item, key, keyPath }) {}
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/siderBar.vue